import { reactive } from 'vue';

export const integracaoPosStore = reactive({
  pos: [],
});
